module.exports = __webpack_public_path__ + "files/c2c61dd2ce0e88ec915b150894f5e92b.png";